const english = {
    pageTitle: "Supplier Category List",
    addSupplierCategory: "Add Supplier Category",
    editSupplierCategory: "Edit Supplier Category",
    action: "Action",
    edit: "Edit",
    delete: "Delete",
    deleteConfirm: "Are you sure?",
    deleteText: "You won't be able to revert this!",
    yes: "Yes, delete it!",
    no: "No",
    cancel: "Cancel",
    supplierCategory: "Supplier Category",
    sl: "Sl",
    update: "Update",
    save: "Save",
    back: "Back",
    message: "Your data has been deleted.",
    deleted: "Deleted!"
};
const malay = {
    pageTitle: "Senarai Kategori Pembekal",
    addSupplierCategory: "Tambah Kategori Pembekal",
    editSupplierCategory: "Sunting Kategori Pembekal",
    action: "Tindakan",
    edit: "Sunting",
    delete: "Padam",
    deleteConfirm: "Adakah anda pasti?",
    deleteText: "Anda tidak akan dapat mengembalikannya!",
    yes: "Ya, padamkan!",
    no: "Tidak",
    cancel: "Batal",
    supplierCategory: "Kategori Pembekal",
    sl: "No",
    update: "Kemas Kini",
    save: "Simpan",
    back: "Kembali",
    message: "Data anda telah dipadam.",
    deleted: "Dipadam!"
};
const thai = {
    pageTitle: "รายการหมวดหมู่ผู้จำหน่าย",
    addSupplierCategory: "เพิ่มหมวดหมู่ผู้จำหน่าย",
    editSupplierCategory: "แก้ไขหมวดหมู่ผู้จำหน่าย",
    action: "การดำเนินการ",
    edit: "แก้ไข",
    delete: "ลบ",
    deleteConfirm: "คุณแน่ใจหรือไม่?",
    deleteText: "คุณจะไม่สามารถย้อนกลับได้!",
    yes: "ใช่, ลบเลย!",
    no: "ไม่",
    cancel: "ยกเลิก",
    supplierCategory: "หมวดหมู่ผู้จำหน่าย",
    sl: "ลำดับ",
    update: "อัปเดต",
    save: "บันทึก",
    back: "กลับ",
    message: "ข้อมูลของคุณถูกลบแล้ว.",
    deleted: "ลบแล้ว!"
};
const arabic = {
    pageTitle: "قائمة فئات الموردين",
    addSupplierCategory: "إضافة فئة مورد",
    editSupplierCategory: "تعديل فئة المورد",
    action: "الإجراء",
    edit: "تعديل",
    delete: "حذف",
    deleteConfirm: "هل أنت متأكد؟",
    deleteText: "لن تتمكن من التراجع عن هذا!",
    yes: "نعم، احذفه!",
    no: "لا",
    cancel: "إلغاء",
    supplierCategory: "فئة المورد",
    sl: "تسلسل",
    update: "تحديث",
    save: "حفظ",
    back: "رجوع",
    message: "تم حذف بياناتك.",
    deleted: "تم الحذف!"
};
const bengali = {
    pageTitle: "সরবরাহকারী শ্রেণী তালিকা",
    addSupplierCategory: "সরবরাহকারী শ্রেণী যোগ করুন",
    editSupplierCategory: "সরবরাহকারী শ্রেণী সম্পাদনা করুন",
    action: "কর্ম",
    edit: "সম্পাদনা",
    delete: "মুছুন",
    deleteConfirm: "আপনি কি নিশ্চিত?",
    deleteText: "আপনি এটি পুনরুদ্ধার করতে পারবেন না!",
    yes: "হ্যাঁ, মুছে ফেলুন!",
    no: "না",
    cancel: "বাতিল",
    supplierCategory: "সরবরাহকারী শ্রেণী",
    sl: "ক্রমিক",
    update: "আপডেট",
    save: "সংরক্ষণ",
    back: "ফিরে যান",
    message: "আপনার তথ্য মুছে ফেলা হয়েছে।",
    deleted: "মুছে ফেলা হয়েছে!"
};


export const supplierCategoryLang = {
    english: english,
    malay: malay,
    thai: thai,
    arabic: arabic,
    bengali: bengali
}